import { NgModule } from '@angular/core';

import { AppleDeviceService } from '../shared/components/apple-device/apple-device.service';
import { ActiveDeviceSyncsSignalR } from './signalr/active-device-syncs.signalr';
import { DeviceSyncStatusSignalR } from './signalr/device-sync-status.signalr';
import { DeviceScheduledTasksSignalR } from './signalr/device-task-management/device-scheduled-tasks.signalr';
import { DevicesSignalR } from './signalr/devices.signalr';
import { PairingSignalR } from './signalr/pairing.signalr';
import { DeviceConfiguredApplicationsStoreModule } from './sub-features/applications-on-device/device-configured-applications-store';
import { DeviceInstalledApplicationsStoreModule } from './sub-features/applications-on-device/device-installed-applications-store';
import { AppleDeviceResolver } from './sub-features/applications-on-device/resolvers/apple-device.resolver';
import { DeviceApplicationSyncStatusResolver } from './sub-features/applications-on-device/resolvers/device-application-sync-status.resolver';
import { DeviceConfiguredApplicationsResolver } from './sub-features/applications-on-device/resolvers/device-configured-application.resolver';
import { DeviceSyncStatusResolver } from './sub-features/applications-on-device/resolvers/device-sync-status.resolver';
import { DeviceResolver } from './sub-features/applications-on-device/resolvers/device.resolver';
import { UnassignedDevicesResolver } from './sub-features/applications-on-device/resolvers/unassigned-devices.resolver';
import { UnavailableDevicesResolver } from './sub-features/applications-on-device/resolvers/unavailable-devices.resolver';
import { DeviceAssignmentHistoryStoreModule } from './sub-features/device-assignment/assignment-history/device-assignment-history-store';
import { DeviceAssignmentHistoryResolver } from './sub-features/device-assignment/assignment-history/device-assignment-history.resolver';
import { DeviceLocationStoreModule } from './sub-features/device-geo-location/device-location-store';
import { DeviceLocationResolver } from './sub-features/device-geo-location/device-location-store/device-location.resolver';
import { NoteResolver } from './sub-features/device-notes/note.resolver';
import { NotesStoreModule } from './sub-features/device-notes/notes-store';
import { AllowedOsUpdatesStoreModule } from './sub-features/device-os-updates/device-allowed-os-updates-store';
import { DeviceAllowedOsUpdatesResolver } from './sub-features/device-os-updates/device-allowed-os-updates-store/device-allowed-os-updates.resolver';
import { DevicesOsUpdateStatusesStoreModule } from './sub-features/device-os-updates/devices-os-update-statuses-store';
import { DeviceOsUpdateStatusResolver } from './sub-features/device-os-updates/devices-os-update-statuses-store/device-os-update-status.resolver';
import { DevicesOsUpdateStatusResolver } from './sub-features/device-os-updates/devices-os-update-statuses-store/devices-os-update-status.resolver';
import { PairingStoreModule } from './sub-features/device-pairing/pairing-store';
import { DeviceActiveSyncCountResolver } from './sub-features/device-sync/device-active-sync-count.resolver';
import { DeviceActiveSyncsStoreModule } from './sub-features/device-sync/device-active-syncs-store';
import { DeviceScheduledTasksStoreModule } from './sub-features/device-sync/device-scheduled-tasks-store';
import { DeviceScheduledTasksResolver } from './sub-features/device-sync/device-scheduled-tasks-store/device-scheduled-tasks.resolver';
import { DeviceSyncStatusesStoreModule } from './sub-features/device-sync/device-sync-statuses-store';

@NgModule({
  imports: [
    DeviceConfiguredApplicationsStoreModule,
    DeviceInstalledApplicationsStoreModule,
    DeviceActiveSyncsStoreModule,
    DeviceAssignmentHistoryStoreModule,
    PairingStoreModule,
    DeviceSyncStatusesStoreModule,
    DevicesOsUpdateStatusesStoreModule,
    DeviceScheduledTasksStoreModule,
    AllowedOsUpdatesStoreModule,
    NotesStoreModule,
    DeviceLocationStoreModule,
  ],
  providers: [
    DeviceResolver,
    UnassignedDevicesResolver,
    UnavailableDevicesResolver,
    AppleDeviceResolver,
    DeviceSyncStatusResolver,
    DeviceConfiguredApplicationsResolver,
    DeviceApplicationSyncStatusResolver,
    DeviceActiveSyncCountResolver,
    DeviceAssignmentHistoryResolver,
    NoteResolver,
    DeviceScheduledTasksResolver,
    DeviceAllowedOsUpdatesResolver,
    DeviceOsUpdateStatusResolver,
    DevicesOsUpdateStatusResolver,
    DeviceLocationResolver,
    PairingSignalR,
    DeviceSyncStatusSignalR,
    DevicesSignalR,
    DeviceScheduledTasksSignalR,
    AppleDeviceService,
    ActiveDeviceSyncsSignalR,
  ],
})
export class EraDevicesLibModule {
  constructor(
    private readonly mdmProcessingStatusSignalR: DeviceSyncStatusSignalR,
    private readonly pairingSingalR: PairingSignalR,
    private readonly devicesSignalR: DevicesSignalR,
    private readonly deviceScheduledTasksSignalR: DeviceScheduledTasksSignalR
  ) {}
}
